import { cn } from '@quadralize/utils'
import type * as React from 'react'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('animate-pulse rounded-md bg-bg-muted', className)} {...props} />
}

export { Skeleton }
